import { atom } from "recoil";

export const fortuneWheelModalStore = atom({
	key: "fortuneWheelModal",
	default: {
		show: false,
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: false,
		},
		currentSearch: "",
		sorting: {
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
